import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "../Loader";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export const Header = (props) => (
	<div className='content-box-header'>
		<h3 id='header-title' className='box-header-title'>
			{props.title}
		</h3>
		{props.isClosedWithoutSubmit ? (
			<span className='close-overlay' onClick={props.onSubmit}>
				<FontAwesomeIcon icon={faTimes} className='icon' />
			</span>
		) : props.isQuizTimer ? (
			<span className='close-overlay' onClick={props.setCloseOverlay}>
				<FontAwesomeIcon icon={faTimes} className='icon' />
			</span>
		) : props.lastPathname ? (
			<Link to={props.lastPathname} className='close-overlay'>
				<FontAwesomeIcon icon={faTimes} className='icon' />
			</Link>
		) : props.setCloseOverlay ? (
			<span className='close-overlay' onClick={props.setCloseOverlay}>
				<FontAwesomeIcon icon={faTimes} className='icon' />
			</span>
		) : (
			<span
				className='close-overlay'
				onClick={() => {
					if (window.document.referrer) {
						props.history.goBack()
					} else {
						const { pathname } = props.history.location
						const edit = pathname.indexOf('/edit')
						const course = pathname.indexOf('/course')

						if (edit !== -1) {
							props.history.push(pathname.slice(0, edit + 5))
						} else if (course !== -1) {
							props.history.push(pathname.slice(0, course + 7))
						} else {
							props.history.push('/dashboard')
						}
					}
				}}
			>
				<FontAwesomeIcon icon='times' className='icon' />
			</span>
		)}
		{props.children}
	</div>
)

export const Content = (props) => (
	<div
		className={`content-box-content scrollbar ${props.cn || ''}`}
		style={{ ...(props.style || {}) }}
	>
		{props.children && props.children.props ? (
			props.children.props.groupsLoading ? (
				<div style={{ textAlign: 'center', marginTop: '50px' }}>
					<Loader />
				</div>
			) : (
				props.children
			)
		) : (
			props.children
		)}
	</div>
)

class Overlay extends Component {
	componentDidMount() {
		document.body.classList.add('overlay-showing')
	}

	componentWillUnmount() {
		document.body.classList.remove('overlay-showing')
	}

	render() {
		var childrenWithProps = React.Children.map(this.props.children, (child) => {
			return React.cloneElement(child, { history: this.props.history })
		})

		return (
			<div className={`${this.props.cn || 'main-overlay-opac-small'}`}>
				<div
					role='dialog'
					aria-labelledby='box-header-title'
					className='main-overlay-content content-box content-box-with-header'
					style={{ ...(this.props.style || {}) }}
				>
					{childrenWithProps}
				</div>
			</div>
		)
	}
}

export default withRouter(Overlay)
